/**
 * Class for audio data handling.
 * @class AudioClip
 * @extends RawAsset
 * @constructor
 */
var AudioClip = cc.Class({
    name: 'cc.AudioClip',
    extends: cc.RawAsset,
});

cc.AudioClip = AudioClip;
module.exports = AudioClip;
